<template>
  <div
    class="menu-trigger"
    flex="dir:right main:center cross:center"
    :class="[isEmpty(position) ? '' : 'absolute-el']"
    :style="{ ...position, ...customStyle }"
  >
    <span>{{ label }}</span>
  </div>
</template>

<script lang="ts" setup>
import { isEmpty } from "lodash-es"
import { watch } from "vue"

interface MenuTriggerProps {
  id: string
  label: string
  position?: any
  customStyle?: any
}

const props = withDefaults(defineProps<MenuTriggerProps>(), {
  label: "标题",
})

const emit = defineEmits(["update:label"])

watch(
  () => props.label,
  val => {
    emit("update:label", val)
  },
  { immediate: true },
)
</script>

<style scoped lang="scss">
.menu-trigger {
  width: 196px;
  height: 40px;
  background-image: url("./assets/bg_menu_regular.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 16px;
  cursor: pointer;

  & > span {
    color: #a6f1feff;
    font-size: 18px;
    font-weight: bold;
    line-height: 21px;
  }
}

.menu-trigger.active,
.menu-trigger:hover {
  background-image: url("./assets/bg_menu_hover.png");
  color: #a6f1feff;
}
</style>
